import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-object-delete',
  templateUrl: './object-delete.component.html',
  styleUrls: ['./object-delete.component.css']
})
export class ObjectDeleteComponent implements OnInit {

  allTemplates: any= []
  singleTemplate: any = []
  objectTemplateId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];

  constructor( private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllObjectTemplate()
    // this.objectForm = this.fb.group({
    //   description: [''],
    //   name: [''],
    //   type: [''],
    //   group: [''],
    //   nameValue:this.fb.array([])
    // }) 
    // this.addNameValue()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllObjectTemplate();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllObjectTemplate();
  }

  // get objectArr(){
  //   return this.objectForm.get('nameValue') as FormArray;
  // }

  // nameValue(){
  //   return this.fb.group({
  //     "key": ['']
  //   })
  // }
  
  // addNameValue(){
  // this.objectArr.push(this.nameValue())
  // }

  // removeNameValue(index: number){
  // this.objectArr.removeAt(index)
  // }

  // addObjectTemplate(){
  //   let body = {
  //     "version": 0,
  //     "isActive": true,
  //     "description": String(this.objectForm.get('description').value),
  //     "name": String(this.objectForm.get('name').value),
  //     "type": String(this.objectForm.get('type').value),
  //     "group": String(this.objectForm.get('group').value),
  //     "nameValue": this.objectForm.get('nameValue').value
  //   }
  //   console.log(body)
  //   this.generic_service.addObjectTemplate(body).subscribe(
  //     (response:any)=>{
  //       console.log(response)
  //       this.objectForm.reset()
  //       this.toastr.success(response.message)
  //       this.cancelModel()
  //     },
  //     (error:any)=>{
  //       console.log(error)
  //     }
  //   )
  // }

  getAllObjectTemplate(){
    this.generic_service.getAllObjectTemplate().subscribe(
      (response:any)=>{
        console.log(response)
        this.allTemplates = response.response
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton1")?.click()
  }

  // getObjectTemplateById(id:any){
  //   this.generic_service.getObjectTemplateById(id).subscribe(
  //     (response:any)=>{
  //       console.log(response)
  //       this.singleTemplate = []
  //       this.singleTemplate.push(response.response);
  //       document.getElementById("template-view")?.click()
  //     },
  //     (error:any)=>{
  //       console.log(error)
  //     }
  //   )
  // }

  del(id:any){
    this.objectTemplateId = id;
    console.log(this.objectTemplateId)
  }

  deleteObjectTemplate(){
    this.generic_service.deleteObjectTemplate(this.objectTemplateId).subscribe(
      (response:any)=>{
        console.log(response);
        this.getAllObjectTemplate()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

}
